export const SETTINGS_REQUEST = 'SETTINGS_REQUEST';
export const SETTINGS_RESPONSE = 'SETTINGS_RESPONSE';
export const SETTINGS_ERROR = 'SETTINGS_ERROR';
export const DISMISS_BANNER = 'DISMISS_BANNER';

export function getSettings() {
  return { type: SETTINGS_REQUEST };
}